module.exports = __webpack_public_path__ + "static/media/riskScoringSystem.d6af944d.mp3";